import { render, staticRenderFns } from "./EgrnFreeForm.vue?vue&type=template&id=13df7a78&scoped=true&"
import script from "./EgrnFreeForm.vue?vue&type=script&lang=ts&"
export * from "./EgrnFreeForm.vue?vue&type=script&lang=ts&"
import style0 from "./EgrnFreeForm.vue?vue&type=style&index=0&id=13df7a78&lang=scss&scoped=true&"
import style1 from "./EgrnFreeForm.vue?vue&type=style&index=1&module=col&lang=css&"




function injectStyles (context) {
  
  this["col"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "13df7a78",
  null
  
)

export default component.exports